var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Workspace, Property 2=Active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 10C41 7.79086 39.2091 6 37 6H13C10.7909 6 9 7.79086 9 10V40C9 42.2091 10.7909 44 13 44H37C39.2091 44 41 42.2091 41 40V10ZM13 9H37L37.1166 9.00673C37.614 9.06449 38 9.48716 38 10V40L37.9933 40.1166C37.9355 40.614 37.5128 41 37 41H13L12.8834 40.9933C12.386 40.9355 12 40.5128 12 40V10L12.0067 9.88338C12.0645 9.38604 12.4872 9 13 9ZM26 18H24V21H26V18ZM18 29H20V32H18V29ZM32 29H30V32H32V29Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11C14.4477 11 14 11.4477 14 12V16C14 16.5523 14.4477 17 15 17H35C35.5523 17 36 16.5523 36 16V12C36 11.4477 35.5523 11 35 11H15ZM15 22C14.4477 22 14 22.4477 14 23V27C14 27.5523 14.4477 28 15 28H35C35.5523 28 36 27.5523 36 27V23C36 22.4477 35.5523 22 35 22H15ZM14 34C14 33.4477 14.4477 33 15 33H23C23.5523 33 24 33.4477 24 34V38C24 38.5523 23.5523 39 23 39H15C14.4477 39 14 38.5523 14 38V34ZM27 33C26.4477 33 26 33.4477 26 34V38C26 38.5523 26.4477 39 27 39H35C35.5523 39 36 38.5523 36 38V34C36 33.4477 35.5523 33 35 33H27Z",
    fill: "#0075E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceActive);
export default __webpack_public_path__ + "static/media/workspace-active.c68403c93071aa7ceff387352cf43ba4.svg";
export { ForwardRef as ReactComponent };